// 司机管理
export default [
  {
    path: '/contractConfig',
    name: 'contractConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/driverConfig/contractConfig.vue'], resolve)
    }
  },
  {
    path: '/driverInfo',
    name: 'driverInfo',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/driverConfig/driverInfo.vue'], resolve)
    }
  },
  {
    path: '/driverInlist',
    name: 'driverInlist',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/driverConfig/driverInlist.vue'], resolve)
    }
  },
  {
    path: '/histroyPerformance',
    name: 'histroyPerformance',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/driverConfig/histroyPerformance.vue'], resolve)
    }
  },
  {
    path: '/performanceConfig',
    name: 'performanceConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/driverConfig/performanceConfig.vue'], resolve)
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/driverConfig.js